/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CategoryInputs */

const en_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category *`)
};

const es_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría *`)
};

const fr_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie *`)
};

const de_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie *`)
};

const ja_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カテゴリ *`)
};

const zh_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类别 *`)
};

const ar_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة *`)
};

const id_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori *`)
};

const it_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria *`)
};

const ru_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория *`)
};

const pt_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria *`)
};

const ko_category = /** @type {(inputs: CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카테고리 *`)
};

/**
* | output |
* | --- |
* | "Category *" |
*
* @param {CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const category = /** @type {((inputs?: CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_category(inputs)
	if (locale === "es") return es_category(inputs)
	if (locale === "fr") return fr_category(inputs)
	if (locale === "de") return de_category(inputs)
	if (locale === "ja") return ja_category(inputs)
	if (locale === "zh") return zh_category(inputs)
	if (locale === "ar") return ar_category(inputs)
	if (locale === "id") return id_category(inputs)
	if (locale === "it") return it_category(inputs)
	if (locale === "ru") return ru_category(inputs)
	if (locale === "pt") return pt_category(inputs)
	return ko_category(inputs)
});